import { PayloadAction } from '@reduxjs/toolkit'
import { TProductFilters } from '../../../models'

const removeProductFilters = (
  state: TProductFilters[],
  action: PayloadAction<{
    id: number
  }>
) => {
  const index = state.findIndex((item) => item.id === action.payload.id)
  if (index !== -1) {
    state.splice(index, 1)
  }
}

export default removeProductFilters
